import React, { useState, useMemo } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// ─── Static Product Data ─────────────────────────────────────────────────────
const STATIC_PRODUCTS = [
    { id: 1,  name: "100 PIPERS BLENDED MALT SCOTCH WHISKY",           size: "Nips",       category: "IMFL", price: 630,  stock: 50  },
    { id: 2,  name: "100 PIPERS BLENDED MALT SCOTCH WHISKY",           size: "Quarts",     category: "IMFL", price: 2410, stock: 30  },
    { id: 3,  name: "100 PIPERS BLENDED SCOTCH WHISKY AGED 12 YRS",    size: "Quarts",     category: "IMFL", price: 2640, stock: 20  },
    { id: 4,  name: "100 PIPERS EXQUISITE BLENDED SCOTCH WHISKY",      size: "Pint",       category: "IMFL", price: 1100, stock: 40  },
    { id: 5,  name: "100 PIPERS EXQUISITE BLENDED SCOTCH WHISKY",      size: "Nips",       category: "IMFL", price: 580,  stock: 60  },
    { id: 6,  name: "ABSOLUT VODKA",                                    size: "Quarts",     category: "IMFL", price: 2200, stock: 25  },
    { id: 7,  name: "CHIVAS REGAL 12 YEAR",                            size: "Quarts",     category: "IMFL", price: 3500, stock: 15  },
    { id: 8,  name: "JACK DANIELS OLD NO.7",                           size: "Quarts",     category: "IMFL", price: 3200, stock: 18  },
    { id: 9,  name: "ROYAL STAG BARREL SELECT",                        size: "Quarts",     category: "IMFL", price: 920,  stock: 80  },
    { id: 10, name: "ROYAL STAG BARREL SELECT",                        size: "Pint",       category: "IMFL", price: 480,  stock: 90  },
    { id: 11, name: "OFFICER'S CHOICE WHISKY",                         size: "Quarts",     category: "IMFL", price: 780,  stock: 100 },
    { id: 12, name: "OFFICER'S CHOICE WHISKY",                         size: "Nips",       category: "IMFL", price: 210,  stock: 120 },
    { id: 13, name: "MCDOWELL'S NO.1 WHISKY",                          size: "Quarts",     category: "IMFL", price: 870,  stock: 70  },
    { id: 14, name: "BLENDERS PRIDE RESERVE COLLECTION",               size: "Quarts",     category: "IMFL", price: 1450, stock: 35  },
    { id: 15, name: "KINGFISHER STRONG BEER",                          size: "650ml",      category: "BEER", price: 180,  stock: 200 },
    { id: 16, name: "KINGFISHER PREMIUM BEER",                         size: "650ml",      category: "BEER", price: 165,  stock: 180 },
    { id: 17, name: "KINGFISHER STRONG BEER",                          size: "500ml Can",  category: "BEER", price: 145,  stock: 150 },
    { id: 18, name: "BUDWEISER",                                        size: "650ml",      category: "BEER", price: 195,  stock: 120 },
    { id: 19, name: "TUBORG STRONG",                                    size: "650ml",      category: "BEER", price: 185,  stock: 140 },
    { id: 20, name: "HEINEKEN",                                         size: "650ml",      category: "BEER", price: 260,  stock: 80  },
    { id: 21, name: "CARLSBERG ELEPHANT",                              size: "650ml",      category: "BEER", price: 200,  stock: 90  },
    { id: 22, name: "DESI THEKA SHARAB",                               size: "180ml",      category: "Desi", price: 90,   stock: 300 },
    { id: 23, name: "DESI THEKA SHARAB",                               size: "375ml",      category: "Desi", price: 170,  stock: 200 },
    { id: 24, name: "HARYANA COUNTRY LIQUOR",                          size: "180ml",      category: "Desi", price: 75,   stock: 400 },
    { id: 25, name: "HARYANA COUNTRY LIQUOR",                          size: "375ml",      category: "Desi", price: 140,  stock: 250 },
    { id: 26, name: "OLD MONK RUM DESI",                               size: "180ml",      category: "Desi", price: 110,  stock: 160 },
];

const CATEGORIES     = ["IMFL", "BEER", "Desi"];
const PAYMENT_METHODS = ["Cash", "UPI / PhonePay", "Card", "Credit"];

/* ─── Dashboard theme tokens ────────────────────────────── */
const INDIGO   = "#6366F1";
const INDIGO_D = "#4F46E5";
const GREEN    = "#10B981";
const RED      = "#EF4444";
const NAVY     = "#0f172a";
const NAVY2    = "#1e2a45";
const BG       = "#F0F2F8";

const SIZE_COLORS = {
    Nips: "#7C3AED", Quarts: "#0369A1", Pint: "#0891B2",
    "650ml": "#B45309", "500ml Can": "#6D28D9",
    "180ml": "#065F46", "375ml": "#1D4ED8",
};

const fmt = (n) => `₹${Number(n).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;

const CATEGORY_META = {
    IMFL: { icon: "🥃", color: "#6366F1", bg: "#EEF2FF" },
    BEER: { icon: "🍺", color: "#F59E0B", bg: "#FFFBEB" },
    Desi: { icon: "🪣", color: "#10B981", bg: "#ECFDF5" },
};

// ─── Category Tab ─────────────────────────────────────────
function CategoryTab({ label, active, onClick }) {
    const m = CATEGORY_META[label];
    return (
        <button onClick={onClick} style={{
            display: "flex", alignItems: "center", gap: 8,
            padding: "9px 18px", borderRadius: 10,
            border: `2px solid ${active ? m.color : "#E5E7EB"}`,
            background: active ? m.color : "#fff",
            color: active ? "#fff" : m.color,
            fontWeight: 700, fontSize: 13, cursor: "pointer",
            transition: "all .18s",
            boxShadow: active ? `0 4px 14px ${m.color}35` : "none",
        }}>
            <span style={{ fontSize: 18 }}>{m.icon}</span>
            {label}
        </button>
    );
}

// ─── Product Card ─────────────────────────────────────────
function ProductCard({ product, qty, onAdd, onRemove }) {
    const sc = SIZE_COLORS[product.size] || INDIGO;
    return (
        <div style={{
            background: "#fff", borderRadius: 12, padding: "12px 14px",
            display: "flex", alignItems: "center", justifyContent: "space-between",
            boxShadow: qty > 0 ? `0 2px 12px ${INDIGO}20` : "0 1px 4px rgba(0,0,0,0.06)",
            marginBottom: 8,
            border: qty > 0 ? `1.5px solid ${INDIGO}` : "1.5px solid #F0F2F8",
            transition: "all .18s",
        }}>
            <div style={{ flex: 1, minWidth: 0, paddingRight: 10 }}>
                <div style={{ fontWeight: 700, fontSize: 12.5, color: "#111827", lineHeight: 1.4, wordBreak: "break-word" }}>
                    {product.name}
                </div>
                <div style={{ marginTop: 5, display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                    <span style={{ background: sc + "18", color: sc, borderRadius: 6, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>
                        {product.size}
                    </span>
                    <span style={{ fontWeight: 800, color: INDIGO, fontSize: 13 }}>{fmt(product.price)}</span>
                    <span style={{ fontSize: 10, color: "#9CA3AF" }}>#{product.id}</span>
                </div>
            </div>
            {/* Qty control */}
            <div style={{ display: "flex", alignItems: "center", gap: 0, background: qty > 0 ? "#EEF2FF" : "#F9FAFB", borderRadius: 30, padding: "3px 5px", flexShrink: 0 }}>
                <button onClick={onRemove} disabled={qty === 0} style={{
                    width: 30, height: 30, borderRadius: "50%", border: "none",
                    background: qty > 0 ? INDIGO : "#E5E7EB", color: "#fff",
                    fontSize: 17, cursor: qty > 0 ? "pointer" : "default",
                    fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center",
                }}>−</button>
                <span style={{ minWidth: 30, textAlign: "center", fontWeight: 800, fontSize: 14, color: INDIGO }}>{qty}</span>
                <button onClick={onAdd} style={{
                    width: 30, height: 30, borderRadius: "50%", border: "none",
                    background: INDIGO, color: "#fff",
                    fontSize: 17, cursor: "pointer",
                    fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center",
                }}>+</button>
            </div>
        </div>
    );
}

// ─── Cart Item ────────────────────────────────────────────
function CartItem({ item, onAdd, onRemove, onRemoveAll, discount, onDiscountChange }) {
    const [showDiscount, setShowDiscount] = useState(false);
    const sc = SIZE_COLORS[item.size] || INDIGO;
    return (
        <div style={{ borderBottom: "1px solid #F0F2F8", padding: "10px 0" }}>
            <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
                <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: 12, color: "#111827", lineHeight: 1.4 }}>{item.name}</div>
                    <div style={{ fontSize: 11, marginTop: 3, display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
                        <span style={{ background: sc + "18", color: sc, borderRadius: 5, padding: "1px 6px", fontWeight: 700, fontSize: 10 }}>{item.size}</span>
                        <span style={{ color: "#6B7280" }}>{fmt(item.price)} each</span>
                    </div>
                </div>
                {/* qty */}
                <div style={{ display: "flex", alignItems: "center", gap: 3 }}>
                    <button onClick={onRemove} style={{ width: 22, height: 22, borderRadius: "50%", border: `1.5px solid ${INDIGO}`, background: "#EEF2FF", color: INDIGO, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}>−</button>
                    <span style={{ width: 22, textAlign: "center", fontWeight: 700, fontSize: 13, color: "#111827" }}>{item.qty}</span>
                    <button onClick={onAdd} style={{ width: 22, height: 22, borderRadius: "50%", border: `1.5px solid ${INDIGO}`, background: "#EEF2FF", color: INDIGO, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}>+</button>
                </div>
                {/* line total */}
                <div style={{ width: 76, textAlign: "right", flexShrink: 0 }}>
                    <div style={{ fontWeight: 700, fontSize: 13, color: "#111827" }}>{fmt(item.price * item.qty)}</div>
                    <button onClick={() => setShowDiscount(!showDiscount)} style={{ fontSize: 10, color: INDIGO, background: "none", border: "none", cursor: "pointer", padding: 0, textDecoration: "underline" }}>% disc</button>
                </div>
                <button onClick={onRemoveAll} style={{ background: "none", border: "none", cursor: "pointer", color: RED, fontSize: 16, lineHeight: 1, padding: "0 2px", flexShrink: 0 }}>✕</button>
            </div>
            {showDiscount && (
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 6, paddingLeft: 8 }}>
                    <span style={{ fontSize: 11, color: "#6B7280" }}>Item Discount %:</span>
                    <input type="number" min="0" max="100" value={discount}
                        onChange={(e) => onDiscountChange(Number(e.target.value))}
                        style={{ width: 58, padding: "3px 6px", borderRadius: 6, border: `1.5px solid #E5E7EB`, fontSize: 12, color: "#374151" }}
                    />
                </div>
            )}
        </div>
    );
}

// ─── Payment Modal ────────────────────────────────────────
function PaymentModal({ total, onClose, onConfirm }) {
    const [method, setMethod] = useState("Cash");
    const [received, setReceived] = useState("");
    const change = received !== "" ? Math.max(0, Number(received) - total) : 0;

    return (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", backdropFilter: "blur(2px)" }}>
            <div style={{ background: "#fff", borderRadius: 16, overflow: "hidden", width: 420, boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
                {/* Modal header — dark like dashboard */}
                <div style={{ background: `linear-gradient(130deg, ${NAVY} 0%, ${NAVY2} 100%)`, padding: "20px 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div>
                        <div style={{ color: "#fff", fontWeight: 800, fontSize: 16 }}>💳 Process Payment</div>
                        <div style={{ color: "rgba(255,255,255,0.45)", fontSize: 12, marginTop: 2 }}>Select method &amp; confirm</div>
                    </div>
                    <button onClick={onClose} style={{ background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)", color: "#fff", width: 32, height: 32, borderRadius: "50%", cursor: "pointer", fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
                </div>
                {/* Accent bar */}
                <div style={{ height: 3, background: `linear-gradient(90deg, ${INDIGO}, ${INDIGO}55)` }} />

                <div style={{ padding: "20px 24px" }}>
                    {/* Amount */}
                    <div style={{ background: "#EEF2FF", borderRadius: 12, padding: "14px 18px", marginBottom: 18, borderLeft: `4px solid ${INDIGO}` }}>
                        <div style={{ fontSize: 11, color: "#6B7280", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>Amount Due</div>
                        <div style={{ fontSize: 30, fontWeight: 900, color: INDIGO }}>{fmt(total)}</div>
                    </div>

                    {/* Payment method */}
                    <div style={{ marginBottom: 16 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: "#6B7280", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Payment Method</div>
                        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                            {PAYMENT_METHODS.map((m) => (
                                <button key={m} onClick={() => setMethod(m)} style={{
                                    padding: "8px 14px", borderRadius: 8,
                                    border: `2px solid ${method === m ? INDIGO : "#E5E7EB"}`,
                                    background: method === m ? INDIGO : "#F9FAFB",
                                    color: method === m ? "#fff" : "#374151",
                                    fontWeight: 600, fontSize: 12, cursor: "pointer",
                                    transition: "all .15s",
                                }}>{m}</button>
                            ))}
                        </div>
                    </div>

                    {/* Cash received */}
                    {method === "Cash" && (
                        <div style={{ marginBottom: 16 }}>
                            <div style={{ fontSize: 11, fontWeight: 700, color: "#6B7280", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Cash Received</div>
                            <input type="number" value={received} onChange={(e) => setReceived(e.target.value)}
                                placeholder="Enter amount"
                                style={{ width: "100%", padding: "10px 14px", borderRadius: 8, border: `1.5px solid ${received ? INDIGO : "#E5E7EB"}`, fontSize: 15, outline: "none", boxSizing: "border-box", color: "#111827" }}
                            />
                            {received !== "" && (
                                <div style={{ marginTop: 8, padding: "8px 12px", borderRadius: 8, background: change >= 0 ? "#ECFDF5" : "#FEF2F2", borderLeft: `3px solid ${change >= 0 ? GREEN : RED}`, fontSize: 14, fontWeight: 700, color: change >= 0 ? "#065F46" : "#991B1B" }}>
                                    Change: {fmt(change)}
                                </div>
                            )}
                        </div>
                    )}

                    {/* Buttons */}
                    <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
                        <button onClick={onClose} style={{ flex: 1, padding: "12px", borderRadius: 10, border: "1.5px solid #E5E7EB", background: "#F9FAFB", fontWeight: 600, cursor: "pointer", fontSize: 14, color: "#374151" }}>
                            Cancel
                        </button>
                        <button onClick={() => onConfirm(method)} style={{
                            flex: 2, padding: "12px", borderRadius: 10, border: "none",
                            background: `linear-gradient(135deg, ${GREEN}, #059669)`,
                            color: "#fff", fontWeight: 800, cursor: "pointer", fontSize: 14,
                            boxShadow: "0 4px 14px rgba(16,185,129,0.4)",
                            display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                        }}>
                            ✓ Confirm Payment
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

// ─── Main POS Component ───────────────────────────────────
export default function POS() {
    const today = new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });

    const [category, setCategory]               = useState("IMFL");
    const [search, setSearch]                   = useState("");
    const [cart, setCart]                       = useState([]);
    const [itemDiscounts, setItemDiscounts]     = useState({});
    const [billDiscount, setBillDiscount]       = useState(0);
    const [billDiscountOpen, setBillDiscountOpen] = useState(false);
    const [customerName, setCustomerName]       = useState("");
    const [customerOpen, setCustomerOpen]       = useState(false);
    const [paymentOpen, setPaymentOpen]         = useState(false);
    const [orderNo, setOrderNo]                 = useState(1001);

    const filtered = useMemo(() => STATIC_PRODUCTS.filter((p) => {
        const matchCat = p.category === category;
        const q = search.trim().toLowerCase();
        return matchCat && (!q || p.name.toLowerCase().includes(q) || p.size.toLowerCase().includes(q));
    }), [category, search]);

    const getQty       = (id) => (cart.find((c) => c.id === id)?.qty ?? 0);
    const addToCart    = (product) => setCart((prev) => {
        const idx = prev.findIndex((c) => c.id === product.id);
        if (idx >= 0) { const u = [...prev]; u[idx] = { ...u[idx], qty: u[idx].qty + 1 }; return u; }
        return [...prev, { ...product, qty: 1 }];
    });
    const removeFromCart = (id) => setCart((prev) => {
        const idx = prev.findIndex((c) => c.id === id);
        if (idx < 0) return prev;
        if (prev[idx].qty === 1) return prev.filter((c) => c.id !== id);
        const u = [...prev]; u[idx] = { ...u[idx], qty: u[idx].qty - 1 }; return u;
    });
    const removeAllFromCart = (id) => setCart((prev) => prev.filter((c) => c.id !== id));

    const subtotal       = cart.reduce((s, i) => s + i.price * i.qty * (1 - (itemDiscounts[i.id] || 0) / 100), 0);
    const discountAmount = subtotal * (billDiscount / 100);
    const total          = subtotal - discountAmount;
    const totalItems     = cart.reduce((s, i) => s + i.qty, 0);

    const handleClear = () => { setCart([]); setItemDiscounts({}); setBillDiscount(0); setCustomerName(""); setBillDiscountOpen(false); };

    const handleConfirmPayment = (method) => {
        toast.success(`Payment of ${fmt(total)} via ${method} confirmed! Order #${orderNo}`);
        setOrderNo((n) => n + 1);
        handleClear();
        setPaymentOpen(false);
    };

    return (
        <div style={{ display: "flex", height: "100vh", background: BG, overflow: "hidden" }}>
            <ToastContainer position="top-right" autoClose={3000} />

            {/* ══ LEFT PANEL ══════════════════════════════════════════════════ */}
            <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>

                {/* Dark header banner */}
                <div style={{
                    background: `linear-gradient(130deg, ${NAVY} 0%, ${NAVY2} 100%)`,
                    padding: "16px 20px 36px", position: "relative", overflow: "hidden", flexShrink: 0,
                }}>
                    {/* blobs */}
                    <div style={{ position:"absolute", right:-40, top:-40, width:180, height:180, borderRadius:"50%", background: INDIGO+"18", pointerEvents:"none" }} />
                    <div style={{ position:"absolute", right:60, top:20, width:80, height:80, borderRadius:"50%", background: INDIGO+"10", pointerEvents:"none" }} />

                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                            <div style={{ width: 46, height: 46, borderRadius: 13, background: INDIGO+"30", border: `2px solid ${INDIGO}66`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, boxShadow: `0 0 0 5px ${INDIGO}12` }}>
                                🛒
                            </div>
                            <div>
                                <div style={{ color: "#fff", fontWeight: 800, fontSize: 18, letterSpacing: -0.3 }}>Point of Sale</div>
                                <div style={{ color: "rgba(255,255,255,0.45)", fontSize: 12, marginTop: 2 }}>Order #{orderNo} · {today}</div>
                            </div>
                        </div>
                        {/* cart badge */}
                        <div style={{ background: INDIGO, borderRadius: 10, padding: "6px 14px", color: "#fff", fontWeight: 700, fontSize: 13, boxShadow: `0 4px 12px ${INDIGO}55` }}>
                            🛒 {totalItems} item{totalItems !== 1 ? "s" : ""}
                        </div>
                    </div>
                    {/* bottom glow */}
                    <div style={{ position:"absolute", bottom:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${INDIGO}, ${INDIGO}66, transparent)` }} />
                </div>

                {/* Content card overlapping banner */}
                <div style={{ flex: 1, padding: "0 16px 16px", marginTop: -20, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                    <div style={{ background: "#fff", borderRadius: 14, boxShadow: "0 4px 20px rgba(0,0,0,0.08)", overflow: "hidden", border: "1px solid rgba(0,0,0,0.05)", flex: 1, display: "flex", flexDirection: "column" }}>
                        <div style={{ height: 3, background: `linear-gradient(90deg, ${INDIGO}, ${INDIGO}55)` }} />
                        <div style={{ padding: "14px 16px", flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>

                            {/* Categories */}
                            <div style={{ marginBottom: 14 }}>
                                <div style={{ fontSize: 10, fontWeight: 700, color: "#9CA3AF", textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>Category</div>
                                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                    {CATEGORIES.map((cat) => (
                                        <CategoryTab key={cat} label={cat} active={category === cat} onClick={() => { setCategory(cat); setSearch(""); }} />
                                    ))}
                                </div>
                            </div>

                            {/* Search */}
                            <div style={{ position: "relative", marginBottom: 12 }}>
                                <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", fontSize: 15, color: "#9CA3AF" }}>🔍</span>
                                <input type="text" value={search} onChange={(e) => setSearch(e.target.value)}
                                    placeholder="Search products..."
                                    style={{ width: "100%", padding: "9px 36px 9px 36px", borderRadius: 10, border: "1.5px solid #E5E7EB", fontSize: 13, outline: "none", background: "#F9FAFB", boxSizing: "border-box", color: "#374151", transition: "border .15s" }}
                                    onFocus={(e) => e.target.style.borderColor = INDIGO}
                                    onBlur={(e) => e.target.style.borderColor = "#E5E7EB"}
                                />
                                {search && (
                                    <button onClick={() => setSearch("")} style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#9CA3AF", fontSize: 16 }}>✕</button>
                                )}
                            </div>

                            {/* Products header */}
                            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
                                <span style={{ fontSize: 11, fontWeight: 700, color: "#6B7280", textTransform: "uppercase", letterSpacing: 0.8 }}>Products</span>
                                <span style={{ background: INDIGO, color: "#fff", borderRadius: 20, padding: "1px 9px", fontSize: 11, fontWeight: 700 }}>{filtered.length}</span>
                            </div>

                            {/* Product list */}
                            <div style={{ flex: 1, overflowY: "auto", paddingRight: 2 }}>
                                {filtered.length === 0
                                    ? <div style={{ textAlign: "center", color: "#9CA3AF", marginTop: 50, fontSize: 13 }}>No products found</div>
                                    : filtered.map((p) => (
                                        <ProductCard key={p.id} product={p} qty={getQty(p.id)} onAdd={() => addToCart(p)} onRemove={() => removeFromCart(p.id)} />
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ══ RIGHT PANEL / CART ══════════════════════════════════════════ */}
            <div style={{ width: 360, display: "flex", flexDirection: "column", background: "#fff", borderLeft: "1px solid #F0F2F8", boxShadow: "-4px 0 20px rgba(99,102,241,0.08)", flexShrink: 0 }}>

                {/* Cart header */}
                <div style={{ background: `linear-gradient(130deg, ${NAVY} 0%, ${NAVY2} 100%)`, padding: "16px 18px", flexShrink: 0 }}>
                    <div style={{ color: "#fff", fontWeight: 800, fontSize: 15 }}>🧾 Order Summary</div>
                    <div style={{ color: "rgba(255,255,255,0.45)", fontSize: 11, marginTop: 2 }}>
                        {totalItems > 0 ? `${totalItems} item(s) · ${fmt(total)}` : "No items yet"}
                    </div>
                    <div style={{ height: 2, background: `linear-gradient(90deg, ${GREEN}, ${GREEN}55)`, marginTop: 12, borderRadius: 2 }} />
                </div>

                {/* Customer */}
                <div style={{ padding: "12px 16px", borderBottom: "1px solid #F0F2F8", flexShrink: 0 }}>
                    {customerOpen ? (
                        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                            <input autoFocus value={customerName} onChange={(e) => setCustomerName(e.target.value)}
                                placeholder="Customer name / phone"
                                style={{ flex: 1, padding: "8px 10px", borderRadius: 8, border: `1.5px solid ${INDIGO}`, fontSize: 13, outline: "none", color: "#374151" }}
                            />
                            <button onClick={() => setCustomerOpen(false)}
                                style={{ padding: "8px 14px", borderRadius: 8, border: "none", background: INDIGO, color: "#fff", cursor: "pointer", fontWeight: 700, fontSize: 12 }}>Done</button>
                        </div>
                    ) : (
                        <button onClick={() => setCustomerOpen(true)}
                            style={{ width: "100%", display: "flex", alignItems: "center", gap: 10, padding: "8px 10px", borderRadius: 10, border: "1.5px dashed #E5E7EB", background: "#F9FAFB", cursor: "pointer" }}>
                            <span style={{ fontSize: 18 }}>👤</span>
                            <span style={{ color: customerName ? "#111827" : "#9CA3AF", fontWeight: customerName ? 600 : 400, fontSize: 13 }}>
                                {customerName || "+ Add Customer"}
                            </span>
                            {customerName && (
                                <span onClick={(e) => { e.stopPropagation(); setCustomerName(""); }} style={{ marginLeft: "auto", color: RED, fontSize: 15, cursor: "pointer" }}>✕</span>
                            )}
                        </button>
                    )}
                </div>

                {/* Cart items */}
                <div style={{ flex: 1, overflowY: "auto", padding: "8px 16px" }}>
                    {cart.length === 0 ? (
                        <div style={{ textAlign: "center", color: "#D1D5DB", marginTop: 60 }}>
                            <div style={{ fontSize: 52, marginBottom: 12 }}>🛒</div>
                            <div style={{ fontSize: 13, color: "#9CA3AF", fontWeight: 600 }}>Cart is empty</div>
                            <div style={{ fontSize: 11, marginTop: 4, color: "#D1D5DB" }}>Select products from the left panel</div>
                        </div>
                    ) : (
                        cart.map((item) => (
                            <CartItem key={item.id} item={item}
                                onAdd={() => addToCart(item)}
                                onRemove={() => removeFromCart(item.id)}
                                onRemoveAll={() => removeAllFromCart(item.id)}
                                discount={itemDiscounts[item.id] || 0}
                                onDiscountChange={(v) => setItemDiscounts((prev) => ({ ...prev, [item.id]: v }))}
                            />
                        ))
                    )}
                </div>

                {/* Bill discount */}
                <div style={{ borderTop: "1px solid #F0F2F8", padding: "10px 16px", flexShrink: 0 }}>
                    <button onClick={() => setBillDiscountOpen(!billDiscountOpen)}
                        style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", background: "none", border: "none", cursor: "pointer", padding: 0 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <span style={{ background: "#EEF2FF", borderRadius: 6, padding: "3px 8px", fontSize: 12, color: INDIGO, fontWeight: 700 }}>🏷️ Bill Discount</span>
                            {billDiscount > 0 && <span style={{ background: INDIGO, color: "#fff", borderRadius: 20, padding: "1px 8px", fontSize: 11, fontWeight: 700 }}>{billDiscount}%</span>}
                        </div>
                        <span style={{ color: "#9CA3AF", fontSize: 13 }}>{billDiscountOpen ? "▲" : "▼"}</span>
                    </button>
                    {billDiscountOpen && (
                        <div style={{ marginTop: 10, display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                            {[5, 10, 15, 20].map((d) => (
                                <button key={d} onClick={() => setBillDiscount(d)} style={{
                                    padding: "4px 11px", borderRadius: 7,
                                    border: `1.5px solid ${billDiscount === d ? INDIGO : "#E5E7EB"}`,
                                    background: billDiscount === d ? INDIGO : "#F9FAFB",
                                    color: billDiscount === d ? "#fff" : "#374151",
                                    fontSize: 12, cursor: "pointer", fontWeight: 700,
                                }}>{d}%</button>
                            ))}
                            <input type="number" min="0" max="100" value={billDiscount}
                                onChange={(e) => setBillDiscount(Number(e.target.value))}
                                style={{ width: 56, padding: "4px 8px", borderRadius: 7, border: "1.5px solid #E5E7EB", fontSize: 13, outline: "none", color: "#374151" }}
                                placeholder="%"
                            />
                        </div>
                    )}
                </div>

                {/* Totals */}
                <div style={{ padding: "12px 16px", borderTop: "1px solid #F0F2F8", background: "#FAFBFF", flexShrink: 0 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5, fontSize: 13, color: "#6B7280" }}>
                        <span>Subtotal</span>
                        <span style={{ fontWeight: 600, color: "#374151" }}>{fmt(subtotal)}</span>
                    </div>
                    {discountAmount > 0 && (
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5, fontSize: 13, color: GREEN }}>
                            <span>Discount ({billDiscount}%)</span>
                            <span style={{ fontWeight: 600 }}>−{fmt(discountAmount)}</span>
                        </div>
                    )}
                    <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderTop: "1.5px solid #EEF2FF", marginTop: 4 }}>
                        <span style={{ fontWeight: 800, fontSize: 15, color: "#111827" }}>Total</span>
                        <span style={{ fontWeight: 900, fontSize: 20, color: INDIGO }}>{fmt(total)}</span>
                    </div>
                    <div style={{ fontSize: 10, color: "#9CA3AF", textAlign: "right" }}>{totalItems} item(s) · {cart.length} product(s)</div>
                </div>

                {/* Action buttons */}
                <div style={{ padding: "12px 16px 16px", display: "flex", gap: 10, flexShrink: 0 }}>
                    <button onClick={handleClear} disabled={cart.length === 0} style={{
                        flex: 1, padding: "11px", borderRadius: 10,
                        border: `1.5px solid ${cart.length > 0 ? "#FECACA" : "#E5E7EB"}`,
                        background: cart.length > 0 ? "#FEF2F2" : "#F9FAFB",
                        color: cart.length > 0 ? RED : "#D1D5DB",
                        fontWeight: 700, fontSize: 13, cursor: cart.length > 0 ? "pointer" : "default",
                        display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
                        transition: "all .15s",
                    }}>
                        🗑️ Clear
                    </button>
                    <button onClick={() => cart.length > 0 && setPaymentOpen(true)} disabled={cart.length === 0} style={{
                        flex: 2, padding: "11px", borderRadius: 10, border: "none",
                        background: cart.length > 0 ? `linear-gradient(135deg, ${INDIGO}, ${INDIGO_D})` : "#E5E7EB",
                        color: cart.length > 0 ? "#fff" : "#9CA3AF",
                        fontWeight: 800, fontSize: 13,
                        cursor: cart.length > 0 ? "pointer" : "default",
                        boxShadow: cart.length > 0 ? `0 4px 14px ${INDIGO}45` : "none",
                        display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
                        transition: "all .15s",
                    }}>
                        💳 Proceed to Pay
                    </button>
                </div>
            </div>

            {/* Payment Modal */}
            {paymentOpen && (
                <PaymentModal total={total} onClose={() => setPaymentOpen(false)} onConfirm={handleConfirmPayment} />
            )}
        </div>
    );
}
